import { Component, Input, OnInit } from '@angular/core';
import { AddServicesAffectationComponent } from '../../../pages/etablissement/mon-etablissement/components/services-affectation/components/add-services-affectation/add-services-affectation.component';
import { MatDialog } from '@angular/material/dialog';
import { AffectationService } from '../../../services/affectation.service';
import { CustomDialogComponent } from '../../custom-dialog/custom-dialog.component';
import { EtablissementData } from '../../utils/data/etablissments-data';

@Component({
  selector: 'app-service-affectation-action',
  templateUrl: './service-affectation-action.component.html',
  styleUrl: './service-affectation-action.component.scss',
})
export class ServiceAffectationActionComponent implements OnInit {
  @Input() data: any = undefined;
  @Input() column: any = undefined;

  constructor(
    private dialog: MatDialog,
    private affectationService: AffectationService
  ) {}

  ngOnInit() {}

  toggleVisibility() {
    const body = {
      isVisible: !this.data.isvisible,
      serviceAffectationId: this.data.id,
    };
    this.affectationService.toggleVisibilityAffectation(body).subscribe({
      next: (value) => {
        this.affectationService.toggleRefreshData();
      },
    });
  }

  openAddServiceAffectationDialog() {
    const dialog = this.dialog.open(AddServicesAffectationComponent, {
      width: '700px',
      autoFocus: false,
      data: {
        isModify: true,
        affectationData: this.data,
      },
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        this.affectationService.toggleRefreshData();
      }
    });
  }
}
